export const GET_CONTENT_BAR = "GET_CONTENT_BAR";
